import type { Schema, TestContext, ValidationError, AnySchema } from 'yup';

export type StoredValues = Record<
    string,
    { valid?: Array<unknown>; notValid?: Array<{ value: unknown; error: ValidationError }> }
>;

export function createSkipIfNotChangedMethod<TSchema extends AnySchema>() {
    return function (this: TSchema, storedValues: StoredValues = {}, chain: Schema): TSchema {
        return this.test(function (value, context: TestContext) {
            const { path, createError } = context;
            const { valid: storedValidValues, notValid: storedNotValidValues } = storedValues[path] || {
                valid: [],
                notValid: [],
            };

            const storedValid = storedValidValues?.find((v) => v === value);
            const storedNotValid = storedNotValidValues?.find((item) => item.value === value);

            if (storedValid === value && value !== undefined) {
                return true;
            }

            if (storedNotValid && storedNotValid.value === value) {
                return createError({ path, message: storedNotValid.error.message });
            }

            if (value === undefined) {
                return false;
            }

            return chain
                .validate(value, { context })
                .then((resValue) => {
                    storedValues[path] = {
                        ...(storedValues[path] || {}),
                        valid: [...(storedValidValues || []).slice(-4), resValue],
                    };
                    return true;
                })
                .catch((error: ValidationError) => {
                    storedValues[path] = {
                        ...(storedValues[path] || {}),
                        notValid: [...(storedNotValidValues || []).slice(-4), { error, value }],
                    };
                    return createError({ path, message: error.message });
                });
        });
    };
}
